module.exports = __webpack_public_path__ + "static/media/top-bar-iap-backing.6747c0a6.png";